import React, {useEffect} from 'react';
import {Layout as AntdLayout} from "antd"
import {createUseStyles} from "react-jss";
import {useLocation} from "react-router-dom";
import Header, {ListProps} from "./header/Header";

const {Content} = AntdLayout

const useStyles = createUseStyles({
    layout: {
        background: "#ffffff"
    },
    content: {
        margin: 0,
        padding: 24,
        minHeight: 280
    },
    "@media (min-width: 1200px)": {
        content: {
            margin: 0,
            padding: 24,
            minHeight: 280
        }
    }
})

interface LayoutProps {
    children?: React.ReactNode | React.ReactNode[];
}

const Layout: React.FC<LayoutProps> = ({children}) => {
    const classes = useStyles()
    const location = useLocation()

    const list: ListProps[] = [
        {
            title: "Список коротких ссылок",
            link: "/",
            hidden: false
        }
    ]

    useEffect(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }, [location])

    return (
        <AntdLayout className={classes.layout}>
            <Header list={list} title={'Админ-панель URL shortener'}/>
            <Content className={classes.content}>
                {children}
            </Content>
        </AntdLayout>
    );
}

export default Layout;